// src/config/permissions.js
export const PERMISSION_LEVELS = ["None", "Read", "Limited", "Full"];

export const PAGE_DEFINITIONS = [
  { id: "dashboard", label: "Dashboard", route: "/dashboard" },
  { id: "routing", label: "Routing", route: "/routing/routing-status" },
  { id: "routing-x-pos", label: "Routing X POs", route: "/routing/routing-x-pos" },
  { id: "pos", label: "PO Details", route: "/pos" },
  { id: "pending-wms-entry", label: "Pending WMS Entry", route: "/pos/pending-wms-entry" },
  { id: "pricing", label: "Pricing", route: "/pricing" },
  { id: "mrp", label: "MRP", route: "/mrp/mrp-aio" },
  { id: "mrp-inventory", label: "MRP Inventory", route: "/mrp/inventory" },
  { id: "mrp-container-details", label: "MRP Container Details", route: "/mrp/container-details" },
  { id: "mrp-products", label: "MRP Products", route: "/mrp/product" },
  { id: "mrp-walmart-ladder", label: "MRP Walmart Ladder", route: "/mrp/walmart-ladder" },
  { id: "raw-vessels", label: "raw_vessels", route: "/api/wayli/raw-vessels" },
  { id: "raw-vessel-containers", label: "raw_vessel_containers", route: "/api/wayli/raw-vessel-containers" },
  { id: "raw-vessel-consignees", label: "raw_vessel_consignees", route: "/api/wayli/raw-vessel-consignees" },
  {
    id: "my-containers",
    label: "My Containers",
    route: "/my-containers",
    limitedConfigKey: "myContainers",
  },
  { id: "edi-inbox", label: "EDI Inbox", route: "/edi/inbox" },
  { id: "edi-997-drafts", label: "997 Drafts", route: "/edi/997-drafts" },
  { id: "edi-po-status", label: "EDI PO Status", route: "/edi/po-status" },
  { id: "edi-856", label: "Walmart 856", route: "/edi/856" },
  { id: "edi-810", label: "Walmart 810", route: "/edi/810" },
  { id: "admin-home", label: "Admin Home", route: "/admin" },
  { id: "admin-roles", label: "Roles", route: "/admin/roles" },
  { id: "admin-users", label: "User Management", route: "/admin/users" },
  { id: "admin-drayage", label: "Drayage Master", route: "/admin/drayage" },
  { id: "admin-warehouse", label: "Warehouse Master", route: "/admin/warehouse" },
  { id: "admin-ship-points", label: "Ship Point Management", route: "/admin/ship-points" },
  { id: "admin-customers", label: "Customers Master", route: "/admin/customers" },
  { id: "admin-logs", label: "Audit Logs", route: "/admin/logs" },
  { id: "admin-api-logs", label: "API Logs", route: "/admin/api-logs" },
  { id: "admin-pricing-overrides", label: "Pricing Overrides", route: "/admin/pricing-overrides" },
  { id: "admin-ingest-warnings", label: "Ingest Warnings", route: "/admin/ingest-warnings" },
  { id: "admin-product-suggestions", label: "Product Suggestions", route: "/admin/product-suggestions" },
  { id: "admin-snapshots", label: "Snapshots", route: "/admin/snapshots" },
  { id: "admin-cust-api-mappings", label: "API Mappings", route: "/admin/api-mappings" },
  { id: "admin-api-manager", label: "API Manager", route: "/admin/api-manager" },
  { id: "admin-walmart-dc-address-book", label: "Walmart DC Address Book", route: "/admin/walmart-dc-address-book" },
];

export const DEFAULT_MATRIX = {
  Admin: {
    "dashboard": "Full",
    "raw-vessels": "Full",
    "raw-vessel-containers": "Full",
    "raw-vessel-consignees": "Full",
    "routing": "Full",
    "routing-x-pos": "Full",
    "pos": "Full",
    "pending-wms-entry": "Full",
    "pricing": "Full",
    "mrp": "Full",
    "mrp-inventory": "Full",
    "mrp-container-details": "Full",
    "mrp-products": "Full",
    "mrp-walmart-ladder": "Full",
    "my-containers": "Full",
    "edi-inbox": "Full",
    "edi-997-drafts": "Full",
    "edi-po-status": "Full",
    "edi-856": "Full",
    "edi-810": "Full",
    "admin-home": "Full",
    "admin-roles": "Full",
    "admin-users": "Full",
    "admin-drayage": "Full",
    "admin-warehouse": "Full",
    "admin-ship-points": "Full",
    "admin-customers": "Full",
    "admin-logs": "Full",
    "admin-api-logs": "Full",
    "admin-pricing-overrides": "Full",
    "admin-ingest-warnings": "Full",
    "admin-product-suggestions": "Full",
    "admin-snapshots": "Full",
    "admin-cust-api-mappings": "Full",
    "admin-api-manager": "Full",
    "admin-walmart-dc-address-book": "Full",
  },
  Dispatcher: {
    "dashboard": "Full",
    "raw-vessels": "Full",
    "raw-vessel-containers": "Full",
    "raw-vessel-consignees": "Full",
    "routing": "Full",
    "routing-x-pos": "Full",
    "pos": "Full",
    "pending-wms-entry": "Full",
    "pricing": "None",
    "mrp": "Full",
    "mrp-inventory": "Full",
    "mrp-container-details": "Full",
    "mrp-products": "Full",
    "mrp-walmart-ladder": "Full",
    "my-containers": "Limited",
    "edi-inbox": "Read",
    "edi-997-drafts": "Read",
    "edi-po-status": "Read",
    "edi-856": "None",
    "edi-810": "None",
    "admin-home": "None",
    "admin-roles": "None",
    "admin-users": "None",
    "admin-drayage": "Full",
    "admin-warehouse": "Full",
    "admin-ship-points": "Full",
    "admin-customers": "Full",
    "admin-logs": "None",
    "admin-api-logs": "None",
    "admin-pricing-overrides": "None",
    "admin-ingest-warnings": "None",
    "admin-product-suggestions": "None",
    "admin-snapshots": "None",
    "admin-cust-api-mappings": "None",
    "admin-api-manager": "None",
    "admin-walmart-dc-address-book": "None",
  },
  Drayage: {
    "dashboard": "Read",
    "raw-vessels": "Read",
    "raw-vessel-containers": "Read",
    "raw-vessel-consignees": "Read",
    "routing": "Read",
    "routing-x-pos": "Read",
    "pos": "Full",
    "pending-wms-entry": "Full",
    "pricing": "None",
    "mrp": "Full",
    "mrp-inventory": "Full",
    "mrp-container-details": "Full",
    "mrp-products": "Full",
    "mrp-walmart-ladder": "Full",
    "my-containers": "Limited",
    "edi-inbox": "None",
    "edi-997-drafts": "None",
    "edi-po-status": "None",
    "edi-856": "None",
    "edi-810": "None",
    "admin-home": "None",
    "admin-roles": "None",
    "admin-users": "None",
    "admin-drayage": "None",
    "admin-warehouse": "None",
    "admin-ship-points": "None",
    "admin-customers": "None",
    "admin-logs": "None",
    "admin-api-logs": "None",
    "admin-pricing-overrides": "None",
    "admin-ingest-warnings": "None",
    "admin-product-suggestions": "None",
    "admin-snapshots": "None",
    "admin-cust-api-mappings": "None",
    "admin-api-manager": "None",
    "admin-walmart-dc-address-book": "None",
  },
  Warehouse: {
    "dashboard": "Read",
    "raw-vessels": "Read",
    "raw-vessel-containers": "Read",
    "raw-vessel-consignees": "Read",
    "routing": "Read",
    "routing-x-pos": "Read",
    "pos": "Full",
    "pending-wms-entry": "Full",
    "pricing": "None",
    "mrp": "Full",
    "mrp-inventory": "Full",
    "mrp-container-details": "Full",
    "mrp-products": "Full",
    "mrp-walmart-ladder": "Full",
    "my-containers": "Limited",
    "edi-inbox": "None",
    "edi-997-drafts": "None",
    "edi-po-status": "None",
    "edi-856": "None",
    "edi-810": "None",
    "admin-home": "None",
    "admin-roles": "None",
    "admin-users": "None",
    "admin-drayage": "None",
    "admin-warehouse": "None",
    "admin-ship-points": "None",
    "admin-customers": "None",
    "admin-logs": "None",
    "admin-api-logs": "None",
    "admin-pricing-overrides": "None",
    "admin-ingest-warnings": "None",
    "admin-product-suggestions": "None",
    "admin-snapshots": "None",
    "admin-cust-api-mappings": "None",
    "admin-api-manager": "None",
    "admin-walmart-dc-address-book": "None",
  },
  Overview: {
    "dashboard": "Read",
    "raw-vessels": "Read",
    "raw-vessel-containers": "Read",
    "raw-vessel-consignees": "Read",
    "routing": "Read",
    "routing-x-pos": "Read",
    "pos": "Read",
    "pending-wms-entry": "Read",
    "pricing": "None",
    "mrp": "Read",
    "mrp-inventory": "Read",
    "mrp-container-details": "Read",
    "mrp-products": "Read",
    "mrp-walmart-ladder": "Read",
    "my-containers": "Read",
    "edi-inbox": "None",
    "edi-997-drafts": "None",
    "edi-po-status": "None",
    "edi-856": "None",
    "edi-810": "None",
    "admin-home": "None",
    "admin-roles": "None",
    "admin-users": "None",
    "admin-drayage": "None",
    "admin-warehouse": "None",
    "admin-ship-points": "None",
    "admin-customers": "None",
    "admin-logs": "None",
    "admin-api-logs": "None",
    "admin-pricing-overrides": "None",
    "admin-ingest-warnings": "None",
    "admin-product-suggestions": "None",
    "admin-snapshots": "None",
    "admin-cust-api-mappings": "None",
    "admin-api-manager": "None",
    "admin-walmart-dc-address-book": "None",
  },
};

export const DEFAULT_LIMITED_CONFIG = {
  Dispatcher: {
    myContainers: {
      scope: { type: "all", field: null },
      features: {
        addRow: true,
        importData: true,
        exportData: true,
        deleteRows: true,
        saveChanges: true,
        getIbCode: true,
      },
      fieldAccess: {
        order_no: "read",
        status: "auto",
        drayage: "edit",
        warehouse: "edit",
        mbl_no: "edit",
        container: "edit",
        m_closed: "edit",
        etd: "auto",
        eta: "auto",
        pod: "auto",
        arrived: "auto",
        lfd: "read",
        appt_date: "read",
        lrd: "read",
        delivered_dt: "read",
        emptied_dt: "read",
        returned_date: "auto",
      },
    },
  },
  Drayage: {
    myContainers: {
      scope: { type: "company", field: "drayage" },
      features: {
        addRow: false,
        importData: false,
        exportData: true,
        deleteRows: false,
        saveChanges: true,
        getIbCode: true,
      },
      fieldAccess: {
        order_no: "read",
        status: "auto",
        drayage: "read",
        warehouse: "read",
        mbl_no: "read",
        container: "read",
        m_closed: "edit",
        etd: "auto",
        eta: "auto",
        pod: "auto",
        arrived: "auto",
        lfd: "edit",
        appt_date: "edit",
        lrd: "edit",
        delivered_dt: "edit",
        emptied_dt: "read",
        returned_date: "auto",
      },
    },
  },
  Warehouse: {
    myContainers: {
      scope: { type: "company", field: "warehouse" },
      features: {
        addRow: false,
        importData: false,
        exportData: true,
        deleteRows: false,
        saveChanges: true,
        getIbCode: true,
      },
      fieldAccess: {
        order_no: "read",
        status: "auto",
        drayage: "read",
        warehouse: "read",
        mbl_no: "read",
        container: "read",
        m_closed: "edit",
        etd: "auto",
        eta: "auto",
        pod: "auto",
        arrived: "auto",
        lfd: "read",
        appt_date: "read",
        lrd: "read",
        delivered_dt: "read",
        emptied_dt: "edit",
        returned_date: "auto",
      },
    },
  },
};
